import React from 'react'
import { Client, Databases, ID } from "appwrite"
import { useState } from 'react'

const Forms = () => {
  const [email, setemail] = useState('')
  const [Names, setNames] = useState('')
  const [phone, setPhone] = useState('')
  const [message, setMessage] = useState('')
  const create = (e) => {
    const client = new Client()
      .setEndpoint('https://cloud.appwrite.io/v1')
      .setProject('66da9a14000f970c8d3d');

    const databases = new Databases(client);
    e.preventDefault()
    const userDta = databases.createDocument(
      '66da9ac4001752138a64',
      '66da9af2002707555e9c',
      ID.unique(),
      { Names, email, phone, message }
    );
    setNames('')
    setMessage('')
    setPhone('')
    setemail('')
  }

  return (
    <div>
      <div className="container w-3/5 m-auto bg-gray-800 mt-3 mb-3 p-16 max-sm:p-8">
        <form action="onSubmit">
          <div className="flex flex-col mb-5 rounded-md ">
            <label htmlFor="" className='text-white '> Full Name</label>
            <input type="text" id="full-name" name="full-name" value={Names} onChange={(e) => { setNames(e.target.value) }} maxlength="50" required className='h-10 rounded-sm outline-none border-none max-sm:w-full' placeholder='First and Last Name' />
          </div>
          <div className="flex flex-col mb-5">
            <label htmlFor="" className='text-white '>Email</label>
            <input type="email" id="full-name" placeholder='Email'value={email} onChange={(e) => { setemail(e.target.value) }}  name="full-name" maxlength="50" required className='h-10 rounded-sm outline-none border-none max-sm:w-full' />
          </div>
          <div className="flex flex-col mb-5" >
            <label htmlFor="" className='text-white '>Number</label>
            <input type="text" id="full-name" name="full-name" maxlength="50" value={phone} required onChange={(e) => { setPhone(e.target.value) }}  className='h-10 rounded-sm outline-none border-none max-sm:w-full' />
          </div>
          <div className="flex flex-col mb-5">
            <label htmlFor="" className='text-white '>Company Name</label>
            <input type="text" id="full-name" name="full-name" maxlength="50" required className='h-10 rounded-sm outline-none border-none max-sm:w-full' />
          </div><div className="flex flex-col mb-5">
            <label htmlFor="" className='text-white '>What do you want andvertise</label>
            <input type="text" id="full-name" name="full-name" maxlength="50" required className='h-10 rounded-sm outline-none border-none max-sm:w-full' />
          </div>

          <div className="flex flex-col mb-5">
            <label htmlFor="" className='text-white '>What is Your Budget ?</label>
            <input type="text" id="full-name" name="full-name" maxlength="50" required className='h-10 rounded-sm outline-none border-none max-sm:w-full' />
          </div>

          <div className="flex flex-col mb-5">
            <label htmlFor="" className='text-white '>Message</label>
            <textarea rows={4} cols={50} style={{ resize: "none" }} onChange={(e) => setMessage(e.target.value)} value={message} className='h-24 max-sm:w-full' placeholder='Message'></textarea>
          </div>

          <div className="w-full bg-gray-800 outline text-white p-4 rounded-md ">
            <button className='w-full rounded-md'>Submit</button>
          </div>

        </form>


      </div>
    </div>
  )
}

export default Forms